import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tag } from "primereact/tag";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ReportActionSummaryWithName } from "../../../../client";
import { listReportActionLogs } from "../../../../api/routes";
import dashboardStyles from "../Dashboard.module.css";
import sharedStyles from "./shared.module.css";
import styles from "./SubmissionHistoryList.module.css";
import {
  ACTION_TYPE_ICONS,
  ACTION_TYPE_SEVERITY,
  formatLabel,
  formatTimestamp,
} from "./submissionHistoryUtils";

export const SubmissionHistoryList = () => {
  const navigate = useNavigate();
  const { data: summaries, isLoading } = useQuery({
    queryKey: ["submission-history-list"],
    queryFn: listReportActionLogs,
  });

  return (
    <div className={sharedStyles.page}>
      <Card title="Submission History">
        {isLoading ? (
          <div className={sharedStyles.centered}>
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={summaries ?? []}
            paginator
            rows={25}
            sortField="latest_timestamp"
            sortOrder={-1}
            emptyMessage="No submission history found"
            onRowClick={(e) => {
              const row = e.data as ReportActionSummaryWithName;
              if (row.report_id) {
                navigate(`../detail/${row.report_id}`);
              } else if (row.email_message_id) {
                navigate(`../detail/email:${row.email_message_id}`);
              }
            }}
            rowClassName={() => dashboardStyles.row}
            scrollable
            scrollHeight="calc(100vh - 300px)"
            stripedRows
          >
            <Column
              field="company_name"
              header="Company / Subject"
              sortable
              style={{ minWidth: "200px" }}
              body={(row: ReportActionSummaryWithName) =>
                row.company_name ?? row.email_subject ?? "Unknown"
              }
            />
            <Column
              field="report_id"
              header="Report / Message ID"
              sortable
              style={{ width: "280px" }}
              body={(row: ReportActionSummaryWithName) => (
                <span className={styles.monospaceId}>
                  {row.report_id ?? row.email_message_id ?? "—"}
                </span>
              )}
            />
            <Column
              field="latest_action_type"
              header="Latest Event"
              sortable
              style={{ width: "250px" }}
              body={(row: ReportActionSummaryWithName) => (
                <Tag
                  value={formatLabel(row.latest_action_type)}
                  severity={ACTION_TYPE_SEVERITY[row.latest_action_type]}
                  icon={ACTION_TYPE_ICONS[row.latest_action_type]}
                />
              )}
            />
            <Column
              field="latest_timestamp"
              header="Last Activity"
              sortable
              style={{ width: "200px" }}
              body={(row: ReportActionSummaryWithName) =>
                formatTimestamp(row.latest_timestamp)
              }
            />
            <Column
              field="action_count"
              header="Events"
              sortable
              style={{ width: "100px" }}
              body={(row: ReportActionSummaryWithName) => (
                <span className={styles.boldCount}>{row.action_count}</span>
              )}
            />
          </DataTable>
        )}
      </Card>
    </div>
  );
};
